import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { of, Subject } from "rxjs";
import { catchError, debounceTime, filter, switchMap, takeUntil } from "rxjs/operators";
import { SolicitacaoService } from "src/app/_services/solicitacao.service";

/**
 * Campo opcional de e-mail do 2º responsável pelo insumo.
 * Emite o e-mail selecionado da lista, ou "" quando o campo é limpo.
 */
@Component({
  selector: "app-second-responsible-input",
  template: `
    <mat-form-field class="w-100" appearance="fill">
      <mat-label>Email do 2º Responsável pelo carregamento (upload) do insumo (opcional):</mat-label>
      <input
        type="text"
        matInput
        autocomplete="off"
        aria-label="Email do(a) 2º Responsável"
        [matAutocomplete]="autoSecond"
        [formControl]="searchCtrl"
        (input)="onTyping()"
      />
      <button *ngIf="searchCtrl.value" mat-icon-button matSuffix type="button" aria-label="Limpar" (click)="clear()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete #autoSecond="matAutocomplete" (optionSelected)="onSelected($event)">
        <mat-option *ngFor="let user of users" [value]="user.email">{{ user.email }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
  `,
})
export class SecondResponsibleInputComponent implements OnInit, OnDestroy {
  @Input() email = "";
  @Output() emailChange = new EventEmitter<string>();

  searchCtrl = new FormControl("");
  users: any[] = [];
  private destroy$ = new Subject<void>();

  constructor(private solicitacaoService: SolicitacaoService) {}

  ngOnInit(): void {
    this.searchCtrl.setValue(this.email || "", { emitEvent: false });
    this.searchCtrl.valueChanges
      .pipe(
        filter((value) => value?.length > 3),
        debounceTime(500),
        switchMap((value) =>
          this.solicitacaoService.getResponsavelEmailLike(value).pipe(catchError(() => of([])))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((users) => (this.users = users || []));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Texto digitado não é um usuário válido até ser escolhido na lista
  onTyping(): void {
    this.emailChange.emit("");
  }

  onSelected(event: MatAutocompleteSelectedEvent): void {
    this.emailChange.emit(event.option.value);
  }

  /** Limpa o campo sem emitir (usado ao fechar/enviar o modal). */
  reset(): void {
    this.searchCtrl.setValue("", { emitEvent: false });
    this.users = [];
  }

  clear(): void {
    this.searchCtrl.setValue("", { emitEvent: false });
    this.users = [];
    this.emailChange.emit("");
  }
}
